module.exports = __webpack_public_path__ + "img/0603-r.8ade6eda.svg";